import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DEMP_FEATURES } from "src/shared/config";
// import searchIcon from "../../assets/images/ic_search.png";
// import notificationIcon from "../../assets/images/ic_notification_black.png";
// import messageIcon from "../../assets/images/ic_message_open.png"
// import dashboardIcon from "../../assets/images/ic_dashboard.png"
import MenuHeader from "./MenuHeader";
// import { useLoggedInUser } from "../../api/userInfo";
import { useDempStore } from "src/context/stores";
import logoSiamEV from "../../components/report/images/logoSiamEV.png";
import logoThaiPrestige from "../../components/report/images/logoThaiPrestige.png";
import logoTHP from "../../components/report/images/logoTHP.png";
import { usePlantsList } from "src/api/userInfo";
import LanguageSwitcher from "./LanguageSwitcher";

const Header = ({ pageTitle = "Demp", showSubMenu = true, children }) => {
  const [plantId,companyId, dashboardId, functions, hidden] = useDempStore((state) => [state.plantId, state.companyId, state.dashboardId, state.functions, state.hidden]);
  const location = useLocation();
  const { t } = useTranslation("main");
  const { plantsList } = usePlantsList();
  
  // const userFunction = plantsList?.find((company) => company.id === companyId)?.hidden || [];

  // const isVisibleAll = functions?.length === 0 || functions === null;
  const isVisibleAll = hidden?.length === 0 || hidden === null;
  

  let menuList = [
    {
      title: t("header_menu.dashboard"),
      path: `/plant/dashboard/${dashboardId}`,
      visible: !hidden?.includes(DEMP_FEATURES.HEADER.DASHBOARD)
    },
    {
      title: t("header_menu.event"),
      path: "/event-transaction",
      visible: !hidden?.includes(DEMP_FEATURES.HEADER.EVENT)
    },
    {
      title: t("header_menu.analytic"),
      path: "/analytics",
      visible: !hidden?.includes(DEMP_FEATURES.HEADER.ANALYTIC)
    },
    {
      title: t("header_menu.report"),
      path: "/report",
      visible: !hidden?.includes(DEMP_FEATURES.HEADER.REPORT_EN) || !hidden?.includes(DEMP_FEATURES.HEADER.REPORT_EV)
    },
    {
      title: "Other",
      path: "#",
      hasDropdown: true,
      visible: !hidden?.includes(DEMP_FEATURES.HEADER.ESG),
      dropdownItems: [
        {
          title: "ESG",
          path: "/esg"
        }
      ]
    }
  ];


  // console.log("functions",functions,functions.includes(DEMP_FEATURES.HEADER.ESG));


  const subStringMenuPath = (path) => {
    if (path.indexOf("/", 2) === -1) {
      return path;
    } else {
      return path.substring(0, path.indexOf("/", 2));
    }
  };
  const activeMenu =
    location.pathname === "/dashboard"
      ? "/dashboard"
      : `/${location.pathname.split("/")[1]}`;

  
  return (
    <>
      <section className="flex flex-col ">
        <div className="py-2 bg-white demp-header">
          <div className="header-container">
            <div className="header-inner-container">
              <div className="">
                <h1 className="header">{pageTitle}</h1>
              </div>

              <div className="flex flex-row items-center gap-4 w-[30%]">
                <LineBreak />
                {children}
                <LineBreak />
              </div>

              <div className="w-[450px]">
                {companyId === 36 && (
                  // logo company
                  <div className="flex gap-2">
                    <div className="w-[8.75rem] h-10">
                      <img
                        src={logoTHP}
                        alt="logo"
                        className="object-contain w-full h-full"
                      />
                    </div>
                    <div className="w-[8.75rem] h-10">
                      <img
                        src={logoThaiPrestige}
                        alt="logo"
                        className="object-contain w-full h-full"
                      />
                    </div>
                    <div className="w-[8.75rem] h-10">
                      <img
                        src={logoSiamEV}
                        alt="logo"
                        className="object-contain w-full h-full"
                      />
                    </div>
                  </div>
                )}
              </div>

              <div></div>
              <div></div>

             
              <div className="flex items-center justify-center">
                <LanguageSwitcher/>
                <MenuHeader />
              </div>
            </div>
          </div>
        </div>

        {showSubMenu && (
          <div className="demp-sub-header">
            <div className="subheader-container">
              {menuList?.filter((n) => n.visible).map((menu, index) => (
                menu.hasDropdown ? (
                  // Dropdown menu item
                  <div
                    key={menu.title}
                    className="relative div-wrapper group"
                  >
                    <div className="cursor-pointer text-wrapper">
                      {menu.title}
                    </div>
                    <div className="absolute left-0 top-full hidden group-hover:block bg-white shadow-md rounded-md z-10 min-w-[120px]">
                      {menu.dropdownItems.map((item) => (
                        <Link
                          key={item.title}
                          to={item.path}
                          className="block w-full px-4 py-2 text-sm hover:bg-gray-100"
                        >
                          {item.title}
                        </Link>
                      ))}
                    </div>
                  </div>
                ) : (
                  // Regular menu item
                  <div
                    key={menu.title}
                    className={`${
                      plantId !== 408 &&
                      activeMenu === subStringMenuPath(menu.path)
                        ? "active-div-wrapper"
                        : plantId === 408 &&
                          activeMenu === subStringMenuPath(menu.path)
                        ? "bg-[#FFEEEE] items-start flex flex-col gap-3 h-12 justify-center relative w-fit p-4"
                        : "div-wrapper"
                    }`}
                  >
                    <Link
                      to={menu?.path}
                      className={`${
                        plantId !== 408 &&
                        activeMenu === subStringMenuPath(menu.path)
                          ? "active-text-wrapper"
                          : plantId === 408 &&
                            activeMenu === subStringMenuPath(menu.path)
                          ? "text-[#ED1C24] text-xs font-bold tracking-[0] leading-4 relative whitespace-nowrap w-fit -mt-px"
                          : "text-wrapper"
                      }`}
                    >
                      {menu?.title}
                    </Link>
                  </div>
                )
              ))}
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default Header;

const LineBreak = () => {
  return (
    <svg
      width="2"
      height="32"
      viewBox="0 0 2 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="1.3252"
        y1="2.18557e-08"
        x2="1.32519"
        y2="32"
        stroke="#E5E5E5"
      />
    </svg>
  );
};
